module.exports = __webpack_public_path__ + "media/images/pub/background-b08b21df49ebbab7af83bdcc18de310c.jpg";